import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/images/house-tau-logo.jpg';
import './Nav.css';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'The House' },
  { to: '/the-eiffel', label: 'The Eiffel' },
  { to: '/baltsazar', label: 'Baltsazar' },
  { to: '/gallery', label: 'Gallery' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Lock background scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isDark = scrolled || menuOpen;

  return (
    <header className={`nav ${isDark ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner container">
        <Link to="/" className="nav__brand">
          <img src={logo} alt="House TAU crest" className="nav__logo" />
          <span className="nav__brand-text">House TAU</span>
        </Link>

        <nav className="nav__links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => `nav__link ${isActive ? 'is-active' : ''}`}
              end={l.to === '/'}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className={`nav__toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <nav className={`nav__mobile-panel ${menuOpen ? 'is-open' : ''}`}>
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => `nav__mobile-link ${isActive ? 'is-active' : ''}`}
            end={l.to === '/'}
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
